module.exports = __webpack_public_path__ + "static/other/gameVendingMachine.8e8cf10c.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameVendingMachine.json
// module id = 2580
// module chunks = 0